import { NgModule } from '@angular/core';
import { TranslateModule} from "@ngx-translate/core";
import { TranslateService } from '@ngx-translate/core';




@NgModule({
  imports: [TranslateModule],
  exports: [TranslateModule],
  providers: [TranslateService]
})
export class AppTranslationModule {
  constructor(){}
}
